import React, { Component } from 'react';
import './NavbarItem.css';

class NavbarItem extends Component {
  constructor(props){
     super(props)
     this.state = {
       text: this.props.text
     };
  }

  render() {
    return (
      <div className='NavbarItem'>
        <button className='NavbarItem-button paragraph'
                onClick={e => this.props.changePage(e, this.state.text)}>
            {this.state.text}
        </button>
      </div>
    );
  }
}



export default NavbarItem;
